export default function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}


//////////////////
// WEBPACK FOOTER
// /var/www/24tru/releases/20230713222349/htdocs-rails/node_modules/@popperjs/core/lib/utils/getAltAxis.js
// module id = 745
// module chunks = 0 1 2 3 5 6